<template>
    <div class="liquids-item">
        <div class="liquids-item__inner">
            <h3 class="liquids-item__headline">{{liquidItem.Name}}</h3>
            <p class="liquids-item__teaser" v-if="liquidItem.HasDescription" v-html="liquidItem.Description"></p>
            <div class="liquids-item__extra" v-if="liquidItem.HasDetails">
                <div class="liquids-item__extra-row" v-for="(liquidItemDetail, index) in liquidItem.Details" :key="index">
                    <div class="liquids-item__extra-col" v-if="liquidItemDetail.Title.length" >{{liquidItemDetail.Title}}</div>
                    <div class="liquids-item__extra-col" v-if="liquidItemDetail.Description.length" v-html="liquidItemDetail.Description"></div>
                </div>
            </div>
            <section class="products-section" v-show="liquidItem.Products.length">
                <div class="products-items__text">
                    <div class="products-items__headline">{{dictionaries.LiquidIncludedProducts}}</div>
                </div>
                <div class="products-items">
                    <productItem v-for="productItem in liquidItem.Products" :productItem="productItem" :key="productItem.Id"></productItem>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import ProductItem from "./productItem.vue";

    export default {
        name: "liquidItem",
        props: ["liquidItem", "dictionaries", "products"],
        components: {
            ProductItem
        }
    };
</script>